import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { authService } from '@adaptcx/shared/services/auth'
import { useAuthStore } from '@adaptcx/shared/stores/auth'
import { installBrowserApm } from '@adaptcx/shared/observability'

// OTel Phase 8 (va/v2.5.58) — browser tracing. Fire-and-forget; empty
// VITE_API_URL (dev) short-circuits inside installBrowserApm.
const _apiBase = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '')
if (_apiBase) {
  void installBrowserApm({
    serviceName: 'operations-portal',
    otlpEndpoint: `${_apiBase}/api/v1/otlp/v1/traces`,
    propagateTraceHeaderUrls: [/^https?:\/\/api\./],
  })
}

// Styles - use local CSS which imports shared styles via relative paths
import './assets/main.css'

// product.css is now the only design system — no body class scope needed.

const app = createApp(App)
app.use(createPinia())

// v2.5.0 (Ship 11, M-3) — silent-refresh from the httpOnly cookie BEFORE
// the router mounts + user profile cache loads, so route guards see a
// populated access-token store on first render.
// Wrapped in an async IIFE because top-level await isn't in the Vite
// browser targets (Chrome 87 / Safari 14 / ES2020).
;(async () => {
  await authService.ensureFreshAccessToken().catch(() => null)
  app.use(router)
  // Initialize auth state (user profile) after silent refresh so
  // isAuthenticated() sees the newly-populated token store.
  useAuthStore().initFromStorage()
  app.mount('#app')
})()
